import { IdNameList } from "../../../api/services/common/models";
import { MDM_ACTIVITY_SEARCH_TYPE_KEY } from "../../../helpers/constants";
import { LabelValue } from "../../../helpers/types/common";
import { searchMdmActivitySiteCoreKeys } from "../siteCore/SiteCoreKeys";

export interface ActivitySearchFormType {
  searchType?: string;
  activityType: string;
  activityTypeFilter: string;
  topic: string;
  topicFilter: string;
  activityStatus: string;
  programFramework: string;
}

export const ActivitySearchFormKey = {
  searchType: "searchType",
  activityType: "activityType",
  activityTypeFilter: "activityTypeFilter",
  topic: "topic",
  topicFilter: "topicFilter",
  activityStatus: "activityStatus",
  programFramework: "programFramework",
  projectFramework: "projectFramework",
} as const;

export const activitySearchFormDefaultValues = {
  [ActivitySearchFormKey.searchType]: MDM_ACTIVITY_SEARCH_TYPE_KEY.all,
  [ActivitySearchFormKey.activityType]: "",
  [ActivitySearchFormKey.activityTypeFilter]:
    searchMdmActivitySiteCoreKeys.contains,
  [ActivitySearchFormKey.topic]: "",
  [ActivitySearchFormKey.topicFilter]: searchMdmActivitySiteCoreKeys.contains,
  [ActivitySearchFormKey.activityStatus]: "",
  [ActivitySearchFormKey.programFramework]: "",
  [ActivitySearchFormKey.projectFramework]: "",
};

export interface MdmActivitySearchResultFiltersTypes {
  programFrameWork: LabelValue[];
  modality: LabelValue[];
  type: LabelValue[];
}

export interface ModalityType {
  modalityId: string;
  modalityName: string;
}

export interface MdmSearchActivityResultFilterForm {
  activityType: string;
  programFrameWork: string;
  modality: string;
  topic: string;
  units: string;
  type: string;
}

export const MdmSearchActivityResultFilterFormKey = {
  activityType: "activityType",
  programFrameWork: "programFrameWork",
  type: "type",
  modality: "modality",
  topic: "topic",
  units: "units",
} as const;

export interface MdmSearchActivityResultRowValue {
  id: string;
  activityType: string;
  programFrameWorkLst: IdNameList[];
  modalityLst: ModalityType[];
  topicLst: IdNameList[];
  units: string;
  unitsValue: string;
  type: string;
  [key: string]: any;
}

export const MdmSearchActivityResultRowKey = {
  activityType: "activityType",
  type: "type",
  programFrameWorkLst: "programFrameWorkLst",
  modalityLst: "modalityLst",
  topicLst: "topicLst",
  units: "units",
  unitsValue: "unitsValue",
} as const;
